export const LandingPageData=[{
    h1:"Scorpion",
    h2:"Studios",
    BtnText:"Read More",
}]